  <form [formGroup]="tenantForm" class="space-y-4" (submit)="save()">

    <div class="grid grid-cols-1 md:grid-cols-1 gap-4">
      <div class="flex items-center flex-col w-full">
        <input
          type="file"
          #fileInput
          accept="image/*"
          hidden
          (change)="onFileSelected($event)"
        />

        <p-avatar
          *ngIf="tenantForm.value.logoMediaUrl; else noLogo"
          [image]="tenantForm.value.logoMediaUrl"
          class="relative kc-avatar-logo"
          size="xlarge"
          shape="circle"
        >
          <p-button
            icon="pi pi-image"
            [rounded]="true"
            severity="secondary"
            class="absolute kc-avatar-upload-button"
            [disabled]="!canUploadLogo"
            (click)="fileInput.click()"
          />
        </p-avatar>

        <ng-template #noLogo>
          <p-avatar
            icon="pi pi-image"
            class="relative kc-avatar-logo"
            size="xlarge"
            shape="circle"
          >
            <p-button
              icon="pi pi-image"
              [rounded]="true"
              severity="secondary"
              class="absolute kc-avatar-upload-button"
              [disabled]="!canUploadLogo"
              (click)="fileInput.click()"
            />
          </p-avatar>
        </ng-template>
      </div>

    </div>

    <h1>Dati Anagrafici</h1>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Nome Azienda</label>
        <input pInputText formControlName="companyName" class="w-full" />
      </p-float-label>

      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Email</label>
        <input pInputText formControlName="email" class="w-full" />
      </p-float-label>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Indirizzo</label>
        <input pInputText formControlName="address" class="w-full" />
      </p-float-label>
      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">P.IVA</label>
        <input pInputText formControlName="vatNumber" class="w-full" />
      </p-float-label>
    </div>

    <h1 class="">Dati Meta</h1>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">App Id</label>
        <input pInputText formControlName="metaAppId" class="w-full" />
      </p-float-label>

      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Business Account ID</label>
        <input pInputText formControlName="metaWaBusinessAccountId" class="w-full" />
      </p-float-label>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Phone Number ID</label>
        <input pInputText formControlName="metaWaPhoneNumberId" class="w-full" />
      </p-float-label>
      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Phone Number</label>
        <input pInputText formControlName="metaWaPhoneNumber" class="w-full" />
      </p-float-label>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <p-float-label variant="on">
        <label class="block text-sm font-medium mb-1">Meta Auth Token</label>
        <input pInputText formControlName="metaAuthToken" class="w-full" />
      </p-float-label>
    </div>

    <div class="flex justify-end gap-2">
      <p-button label="Cancella" icon="pi pi-times-circle" size="small" severity="secondary" (click)="closeDialog()"/>
      <p-button label="Salva" icon="pi pi-check-circle" size="small" [disabled]="!tenantForm.valid" type="submit"/>
    </div>
  </form>
